/**
 * 全局语言文本配置
 * 统一管理所有组件的多语言文本
 */

export const texts = {
  header: {
    en: {
      login: 'Login',
      profile: 'Profile'
    },
    zh: {
      login: '登录',
      profile: '个人资料'
    }
  },

  hero: {
    en: {
      title: "Your Photo. Your Song. Your Movie.",
      subtitle: "Turn a single photo into your own AI music video."
    },
    zh: {
      title: "讲出你的故事，唱出你的歌",
      subtitle: "一张照片 · 一个主题 · 开启你的AI音乐电影之旅"
    }
  },

  filmStrip: {
    en: {
      passion: '#Passion',
      dream: '#Dream',
      health: '#Health',
      struggle: '#Struggle',
      reunion: '#Reunion',
      romance: '#Romance'
    },
    zh: {
      passion: '#激情',
      dream: '#梦想',
      health: '#健康',
      struggle: '#奋斗',
      reunion: '#团聚',
      romance: '#浪漫'
    }
  },

  generator: {
    en: {
      upload: 'Upload a Photo',
      titlePlaceholder: 'Title (Optional)',
      placeholder: 'Enter your story here, or click inspiration tags below to start quickly...',
      generate: 'Generate MV',
      inspiration: 'Inspiration:',
      pointsRequired: 'Requires',
      points: 'points',
      generating: 'Generating...',
      error: 'Please upload an image file',
      fileTooLarge: 'Image size cannot exceed 10MB',
      selectImage: 'Please upload an image first',
      enterContent: 'Please enter a title or story description',
      insufficientPoints: (required, current) => `Insufficient points. Required: ${required}, Current: ${current}`,
      success: 'Video created successfully! Generating...',
      networkError: 'Network request failed, please try again',
      unnamed: 'Untitled Work',
      myStory: 'My Story',
      cannotGetPoints: 'Unable to retrieve points information',
      videoCreationFailed: 'Video creation failed',
      rechargeRequired: 'Insufficient points, please recharge first',
      alert: (story, duration) => `Starting MV Generation!\nStory: ${story}\nDuration: ${duration} seconds`,
      template: (tag) => `I want to generate an MV about "${tag}", hoping for a unique visual style with an emotional melody.`
    },
    zh: {
      upload: '上传一张照片',
      titlePlaceholder: '标题（可选）',
      placeholder: '在这里输入你的故事片段，或者点击下方的灵感标签快速开始...',
      generate: '生成 MV',
      inspiration: '灵感触达:',
      pointsRequired: '需要',
      points: '积分',
      generating: '生成中...',
      error: '请上传图片文件',
      fileTooLarge: '图片大小不能超过 10MB',
      selectImage: '请先上传图片',
      enterContent: '请输入标题或主题描述',
      insufficientPoints: (required, current) => `积分不足，需要 ${required} 积分，当前 ${current} 积分`,
      success: '视频创建成功！正在生成中...',
      networkError: '网络请求失败，请重试',
      unnamed: '未命名作品',
      myStory: '我的故事',
      cannotGetPoints: '无法获取积分信息',
      videoCreationFailed: '视频创建失败',
      rechargeRequired: '积分不足，请先充值',
      alert: (story, duration) => `开始生成MV！\n故事: ${story}\n时长: ${duration}秒`,
      template: (tag) => `我想生成一个关于"${tag}"的MV，希望视觉风格独特且带有感人的旋律。`
    }
  },

  showcase: {
    en: {
      title: 'Video Templates',
      featured: 'FEATURED'
    },
    zh: {
      title: '视频模板',
      featured: '精选'
    }
  },

  footer: {
    en: "© 2026 MVME STUDIO - Empowering Everyone with Cinematic Creativity",
    zh: "© 2026 MVME STUDIO - 赋予每个人电影级的创作力"
  },

  login: {
    en: {
      title: 'Welcome to MVME',
      subtitle: 'Sign in to continue',
      googleSignIn: 'Sign in with Google',
      emailContinue: 'Continue with Email',
      login: 'Login',
      register: 'Register',
      forgotPassword: 'Forgot Password?',
      email: 'Email',
      password: 'Password',
      name: 'Name',
      confirmPassword: 'Confirm Password',
      noAccount: "Don't have an account?",
      hasAccount: 'Already have an account?',
      back: 'Back',
      submit: 'Sign In',
      registerSubmit: 'Create Account',
      resetSubmit: 'Send Reset Link',
      success: 'Success!',
      error: 'Something went wrong. Please try again.',
      passwordMismatch: 'Passwords do not match',
      registrationSuccess: 'Registration successful! Please login.',
      registrationSuccessDemo: 'Registration successful! (Demo Mode)',
      passwordResetSent: 'Password reset email sent!',
      backToLogin: 'Back to'
    },
    zh: {
      title: '欢迎来到MVME',
      subtitle: '登录以继续',
      googleSignIn: '使用Google账户登录',
      emailContinue: '使用电子邮箱继续',
      login: '登录',
      register: '注册',
      forgotPassword: '忘记密码？',
      email: '电子邮箱',
      password: '密码',
      name: '姓名',
      confirmPassword: '确认密码',
      noAccount: '还没有账户？',
      hasAccount: '已有账户？',
      back: '返回',
      submit: '登录',
      registerSubmit: '创建账户',
      resetSubmit: '发送重置链接',
      success: '成功！',
      error: '出错了，请重试。',
      passwordMismatch: '密码不匹配',
      registrationSuccess: '注册成功！请登录。',
      registrationSuccessDemo: '注册成功！(演示模式)',
      passwordResetSent: '密码重置邮件已发送！',
      backToLogin: '返回'
    }
  },

  myWorks: {
    en: {
      title: 'My Works',
      loading: 'Loading...',
      empty: 'No works yet, create your first video now!',
      refresh: 'Refresh',
      share: 'Share',
      download: 'Download',
      play: 'Play',
      workInProgress: 'Work is in progress, please wait.'
    },
    zh: {
      title: '我的作品',
      loading: '加载中...',
      empty: '暂无作品，快去创建你的第一个视频吧！',
      refresh: '刷新',
      share: '分享',
      download: '下载',
      play: '播放',
      workInProgress: '作品正在生成中，请稍后再试'
    }
  }
};

/**
 * 获取指定组件和语言文本的辅助函数
 * @param {string} component - 组件名称 (header, hero, generator, etc.)
 * @param {string} language - 语言代码 (en, zh)
 * @returns {object} 该组件的语言文本对象
 */
export const getTexts = (component, language) => {
  return texts[component]?.[language] || texts[component]?.en || {};
};
